import { render } from "./HeaderReport.vue?vue&type=template&id=17fb6fb7&scoped=true"
import script from "./HeaderReport.vue?vue&type=script&lang=js"
export * from "./HeaderReport.vue?vue&type=script&lang=js"

import "./HeaderReport.vue?vue&type=style&index=0&id=17fb6fb7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fb6fb7"]])

export default __exports__